import { useQuery } from '@apollo/react-hooks'
import { TierSubscription } from 'generated/types'
import tierSubscriptionQuery from './gql/tierSubscriptionByUserId.query.gql'

interface TierSubscriptionResponse {
  tierSubscriptionByUserId: TierSubscription
}

export const useTierSubscription = () => {
  const { data, loading } = useQuery<TierSubscriptionResponse>(
    tierSubscriptionQuery,
  )
  return {
    tierSubscription: data?.tierSubscriptionByUserId,
    isTierSubscriptionLoading: loading,
    subscriptionTierKey: data?.tierSubscriptionByUserId.tier.key,
    subscriptionTierPrice:
      data?.tierSubscriptionByUserId.tierPrice.amount.value,
  }
}
